import { render, staticRenderFns } from "./UpdateClient.vue?vue&type=template&id=b169f6dc&"
import script from "./UpdateClient.vue?vue&type=script&lang=js&"
export * from "./UpdateClient.vue?vue&type=script&lang=js&"
import style0 from "./UpdateClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports